import { persistStore } from "redux-persist"
import createStore from "store-lib/createStore"

export const store = createStore()
export const persistor = persistStore(store)
